import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'


const initialState = {
    categoryList: { categories: [], total: 0, pageSize: 0, error: null, loading: false },
    activeCategory: { category: null, error: null, loading: false },
    newCategory: { category: null, error: null, loading: false },
    updateCategory: { category: null, error: null, loading: false },
    deleteCategory: { category: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_CATEGORIES:
            return {
                ...state,
                categoryList: {
                    ...state.categoryList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                categoryList: {
                    categories: action.payload.categories,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_CATEGORIES_FAILURE:
            return {
                ...state,
                categoryList: {
                    categories: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CATEGORIES:
            return { ...state, categoryList: initialState.categoryList }



        case actionTypes.FETCH_CATEGORY:
            return { ...state, activeCategory: { category: null, error: null, loading: true } }

        case actionTypes.FETCH_CATEGORY_SUCCESS:
            return { ...state, activeCategory: { category: action.payload.category, error: null, loading: false } }

        case actionTypes.FETCH_CATEGORY_FAILURE:
            return { ...state, activeCategory: { category: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_CATEGORY:
            return { ...state, activeCategory: initialState.activeCategory }



        case actionTypes.CREATE_CATEGORY:
            return {
                ...state,
                newCategory: {
                    category: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_CATEGORY_SUCCESS:
            return {
                ...state,
                newCategory: {
                    category: action.payload.category,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_CATEGORY_FAILURE:
            return {
                ...state,
                newCategory: {
                    category: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_CATEGORY:
            return { ...state, newCategory: initialState.newCategory }




        case actionTypes.UPDATE_CATEGORY:
            return { ...state, updateCategory: { category: null, error: null, loading: true } }

        case actionTypes.UPDATE_CATEGORY_SUCCESS:
            return { ...state, updateCategory: { category: action.payload.category, error: null, loading: false } }

        case actionTypes.UPDATE_CATEGORY_FAILURE:
            return { ...state, updateCategory: { category: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_CATEGORY:
            return { ...state, updateCategory: initialState.updateCategory }



        case actionTypes.DELETE_CATEGORY:
            return { ...state, deleteCategory: { category: null, error: null, loading: true } }

        case actionTypes.DELETE_CATEGORY_SUCCESS:
            return { ...state, deleteCategory: { category: action.payload.category, error: null, loading: false } }

        case actionTypes.DELETE_CATEGORY_FAILURE:
            return { ...state, deleteCategory: { category: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_CATEGORY:
            return { ...state, deleteCategory: initialState.deleteCategory }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/category/reducer.js